import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Analytics } from '@vercel/analytics/react';

// Verifica si el elemento 'root' existe antes de crear la raíz
const rootElement = document.getElementById('root');

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
      <Analytics />
    </React.StrictMode>
  );
} else {
  console.error("Error: No se encontró el elemento con id 'root'");
}

// Medición de rendimiento
reportWebVitals(console.log);

